export function GridScripts() {
  setTimeout(function () {
    Array.from(document.getElementsByClassName("list-group")).forEach((el) => {
      el.addEventListener("mouseleave", function (e) {
        el.parentElement.classList.remove("show");
      });
    });
  }, 400);
}
